import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import './Productmain.css';
import { productsData, createSlug } from '../../Helper/index.js';

const filterProducts = (prodCat, subCat) => {
    const category = productsData.find(cat => cat.prodCat === prodCat);
    if (!category) return [];

    const subCategory = category.subCategories.find(sub => sub.subCat === subCat);
    if (!subCategory) return [];

    return subCategory.productscategory;
};

const categories = [
    { title: "COMBINE HARVESTER", subCat: 'Combineharvester' },
    { title: "ROTAVATOR", subCat: 'rotavator' },
    { title: "ROTARY RAKE", subCat: 'rotaryrake' },
    { title: "DSR DRILL", subCat: 'dsrdrill' },
    { title: "LASER LAND LEVELLER", subCat: 'laserlandleveller' },
    { title: "STRAW REAPER", subCat: 'strawreaper' },
    { title: "SQUARE BALER", subCat: 'squarebaler' },
    { title: "SUPER SEEDER", subCat: 'superseeder' }
];

const ProductPagemain = () => {
    const navigate = useNavigate();
    const [activeIndex, setActiveIndex] = useState(0);
    const categoryRefs = useRef([]);

    const handleClick = (index) => {
        setActiveIndex(index);  // Set the active index on click
        if (categoryRefs.current[index]) {
            categoryRefs.current[index].scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };


    const handleExploreClick = (product) => {
        const slug = createSlug(product.modeldesc || product.modelName || product.productName);
        navigate(`/${slug}`, { state: { product } });
        window.scrollTo(0, 0);
    };

    return (
        <>
            {/* Buttons to scroll to each category */}
            <div className="product-main-page">
                {categories.map((category, index) => (
                    <div
                        key={index}
                        className={`button ${activeIndex === index ? 'active' : ''}`}  // Add 'active' class if this is the active button
                        onClick={() => handleClick(index)}
                    >
                        {category.title}
                    </div>
                ))}
            </div>

            {/* All categories displayed with scroll references */}
            <div className="product-category-range">
                {categories.map((category, index) => {
                    const products = filterProducts('ProductCat', category.subCat);

                    return (
                        <div key={index} ref={(el) => (categoryRefs.current[index] = el)} className="category-section">
                            <div className="product-ct-heding">
                                <div className="product-border-line">
                                    <h2>{category.title}</h2>
                                </div>
                                <div className="product-detail-img-range">
                                    {products.length > 0 ? (
                                        products.map((item, idx) => (
                                            <div key={idx} className="product-deatils-desc">
                                                <div className="product-img-deatil">
                                                    <img src={item.imgSrc} alt={item.modelName} />
                                                </div>
                                                <h5>{item.modelName}</h5>
                                                <p>{item.modeldesc}</p>
                                                <div className="row">
                                                    <div className="col-6"><span onClick={() => handleExploreClick(item)}>EXPLORE</span></div>
                                                    <div className="col-6"><span>ASK PRICE</span></div>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <p>No products available</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </>
    );
};

export default ProductPagemain;
